import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { ColumnDef } from "@tanstack/react-table";

import type { DriverRow } from "@/types/driver";
import { minWidthForColumnHeader } from "./columnMinWidth";

function VolumeCell({ driver }: { driver: DriverRow }) {
  const muted = driver.mostRecentVolumeAudible === false;

  if (muted) {
    return (
      <Tooltip title="Device Muted">
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            color: "#ef4444",
          }}
        >
          <VolumeOffIcon sx={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
    );
  }

  if (typeof driver.volume !== "number") return null;

  return <>{Math.round(driver.volume * 100)}%</>;
}

const VOLUME_COLUMN_TITLE = "Device Volume";

export function volumeColumn(): ColumnDef<DriverRow> {
  return {
    accessorKey: "volume",
    header: VOLUME_COLUMN_TITLE,
    cell: ({ row }) => <VolumeCell driver={row.original} />,
    meta: { flex: 1, draggable: true },
    minSize: minWidthForColumnHeader(VOLUME_COLUMN_TITLE, { draggable: true, hasFilter: false }),
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
